import axios from 'axios';
import apiConfig from 'utils/networking/api.config';

export default async function searchByCodeValidationRequest({
  hotelId,
  bookingData,
  authorization = null,
}) {
  const {
    validationsHost,
    URIs: {
      validations: { searches },
    },
  } = apiConfig;
  let action = 'searchByCode';

  const selectedHotel = JSON.parse(localStorage.getItem('selectedHotel'));
  hotelId = selectedHotel?.id;
  let code = bookingData.bookingCode;
  let entranceDate = bookingData.entranceDate;
  let bookingHolder = bookingData.bookingHolder;
  let departureDate = bookingData.departureDate;

  const uri = `${validationsHost}${searches}`
    .replace(':hotelId', hotelId)
    .replace(':action', action || '');

  return axios
    .get(uri, {
      params: { code, entranceDate, bookingHolder, departureDate },
      headers: { Authorization: authorization, 'client-id': 21 },
    })
    .then(res => {
      return res.data;
    });
}
